import { delayedCall, dispatcher, killDelayedCall } from "@quest/base-core";
import { RetriggerController, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther";

export class RetriggerControllerGame extends RetriggerController {

  protected onRetriggerShow(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    dispatcher.fireEvent(SlotEventConstantsBehavior.FADE_IN_SOUND, {
      id: SoundConstant.FREGAME_BGLOOP,
      vol: 0.5,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });
    //this.showRetriggerText();
    this.showRetriggerSpine();
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
      id: SoundConstant.RETRIGGER_POP_UP_SOUND,
      vol: 1,
      loop: false,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });

    //we not need this functionality
    // delayedCall(this.STR_CHANGE_GRID, SlotConstantsBehavior.DURATION_200, () => {
    //     killDelayedCall(this.STR_CHANGE_GRID);
    //     this.updateStaticGrid();
    // }, this);
  }

  // Show retrigger text with fade in effect
  showRetriggerText() {
    // this.retriggerText.x = -700;
    // this.retriggerText.setText(`+${(ingenuity.parserModel as GameParserModel).getRetriggerFreeSpins()} ${this.retriggerText.text}`);
    // this.retriggerText.alpha = 1;
    // this.retriggerText.visible = true;
    // this.retriggerText.rotation = 0;
    // const fadeInTween = ingenuity.currentGame.add.tween(this.retriggerText).to({ x: 100 }, 100, Sinusoidal.InOut, true, 0, 0, false);
    // fadeInTween.onComplete.addOnce(() => {
    //     fadeInTween.stop();
    //     ingenuity.currentGame.tweens.remove(fadeInTween);
    //     const fadeInTween2 = ingenuity.currentGame.add.tween(this.retriggerText).to({ x: 500 }, 1500, Linear.None, true, 0, 0, false);
    //     fadeInTween2.onComplete.addOnce(() => {
    //       const fadeInTween2 = ingenuity.currentGame.add.tween(this.retriggerText).to({ x: 1500 }, 100, Linear.None, true, 0, 0, false);
    //       fadeInTween2.onComplete.addOnce(()=>{
    //         this.hideRetriggerText();
    //         delayedCall(this.STR_COUNTER_ANIM, SlotConstantsBehavior.DURATION_2000, () => {
    //             killDelayedCall(this.STR_COUNTER_ANIM);
    //             this.showFreeGameCounterAnimation();
    //         }, this);
    //       })
    //     });
    // }, this);
  }

  protected playRetriggerDesktopSpine(): void {
    this.retriggerSpine.visible = true;
    this.retriggerSpine2.visible = true;
    this.retriggerSpine.playAnim("bg_desktop", false);
    this.retriggerSpine2.playAnim("freespins_intro", false);
    this.retriggerSpine2.onComplete.addOnce(() => {
      this.showFreeGameCounterAnimation();
      this.retriggerSpine2.visible = false;
      this.retriggerSpine.visible = false;
    }, this);
  }

  // Overrided to play portrait retrigger spine animations
  protected playRetriggerPortraitSpine(): void {
    this.retriggerPortraitSpine.visible = true;
    this.retriggerPortraitSpine2.visible = true;
    this.retriggerPortraitSpine.playAnim("bg_portrait", false);
    this.retriggerPortraitSpine2.playAnim("freespins_intro", false);
    this.retriggerPortraitSpine.onComplete.addOnce(() => {
      this.retriggerPortraitSpine.visible = false;
      this.retriggerPortraitSpine2.visible = false;
    }, this);
  }
  // Update total free spin
  updateTotalFreeSpin() {
    dispatcher.fireEvent(SlotEventConstantsBehavior.FADE_OUT_SOUND, {
      id: SoundConstant.FREGAME_BGLOOP,
      vol: 1,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });
    delayedCall(
      this.STR_NEXT_SNED_PRESENTATION,
      SlotConstantsBehavior.DURATION_400,
      () => {
        killDelayedCall(this.STR_NEXT_SNED_PRESENTATION);
        dispatcher.fireEvent(SlotEventConstantsBehavior.MOVE_TO_NEXT_FREESPIN_AFTER_RETRIGGER);
      },
      this
    );
  }
}
